import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { type RecType } from '@/defs/rec'
import { formatFullNumber } from '@/utils/formatUtil'
import { getRecName, isRecEqual } from '@/utils/recUtil'

type Props = {
  rec: RecType
  variant?: 'commander'
}

export const StatRecDeckTotalTooltip = ({ rec, variant }: Props) => {
  const { page } = usePage()
  const { numDecks } = rec
  const fullName = getRecName(rec)

  if (numDecks === undefined) return null

  const relation =
    variant === 'commander' || (rec.role && ['commander', 'partner', 'partnerPair'].includes(rec.role))
      ? 'the commander for'
      : rec.role === 'companion'
        ? 'the companion for'
        : 'in'

  const isFeatured = isRecEqual(rec, page?.featured?.rec) || rec.role === 'partnerPair'
  const subject = isFeatured ? undefined : page?.metadata?.subject
  const deckType = subject ? (
    page?.route?.section === 'cardsFeatured' ? (
      <>
        decks containing <strong>{subject}</strong>
      </>
    ) : (
      <>
        <strong>{subject}</strong> decks
      </>
    )
  ) : (
    <>decks</>
  )

  return (
    <>
      <h2>
        <IconWithLabel iconBefore='layerGroup'>Deck Total</IconWithLabel>
      </h2>
      <p>
        <strong>{fullName}</strong> is {relation} <strong>{formatFullNumber(numDecks)}</strong> total {deckType}.
      </p>
    </>
  )
}
